import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "discount-type-select" }
const _hoisted_3 = {
  key: 0,
  class: "discount-value-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterOBject,
      filter: true,
      clearInput: true,
      clearInputSelect: true,
      showExport: false,
      showButton: true,
      filterPlaceholder: 'message.SELECT',
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchHandler(1, Number(_ctx.routeParam)))),
      onReloadListing: _cache[2] || (_cache[2] = ($event: any) => (_ctx.get_price_group_products(1, false, null, null, Number(_ctx.routeParam)))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterPlaceholder", "onExportFile"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.productsData,
      pagination: _ctx.pagination,
      padding: 3,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader,
      onSorting: _ctx.searchHandler
    }, {
      "cell-name": _withCtx(({ row: item }) => [
        _createTextVNode(_toDisplayString(JSON.parse(item.name.name)[`${_ctx.system_locale}`]?.name), 1)
      ]),
      "cell-sale_price": _withCtx(({ row: item }) => [
        _createTextVNode(_toDisplayString(item.sale_price), 1)
      ]),
      "cell-discount_type": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Select, {
            name: `discount_type_${item.product_id}`,
            target: "discount_type",
            placeholder: 'message.SELECT',
            clearable: true,
            callEmit: true,
            selectData: _ctx.discountTypeOptions,
            value: item.discount_type,
            discount_type: item.discount_type,
            "onUpdate:discount_type": ($event: any) => (item.discount_type = $event),
            onChange: ($event: any) => (_ctx.handleDiscountTypeChange(item))
          }, null, 8, ["name", "placeholder", "selectData", "value", "discount_type", "onUpdate:discount_type", "onChange"])
        ])
      ]),
      "cell-discount_value": _withCtx(({ row: item }) => [
        _createVNode("input", {
          type: "number",
          step: "any",
          min: "0",
          class: ["form-control position custom", { 'is-invalid': item.discount_error }],
          disabled: !item.discount_type,
          max: item.discount_type === 'PERCENTAGE' ? 100 : item.sale_price,
          value: item?.discount_value,
          onChange: ($event: any) => (_ctx.handleDiscountValueChange(item, $event))
        }, null, 42, ["disabled", "max", "value", "onChange"]),
        (item.discount_error)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(item.discount_error), 1))
          : _createCommentVNode("", true)
      ]),
      "cell-special_price": _withCtx(({ row: item }) => [
        _createVNode("input", {
          type: "number",
          step: "any",
          class: "form-control position custom",
          value: item?.special_price,
          disabled: ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading", "onSorting"])
  ]))
}